import React, { createContext, useContext, ReactNode } from 'react';
import { useChecklistsConfig, ChecklistsConfig } from './useChecklistsConfig';

interface ChecklistsConfigContextType {
  checklistsConfig: ChecklistsConfig;
  loading: boolean;
  error: Error | null;
}

const ChecklistsConfigContext = createContext<ChecklistsConfigContextType | undefined>(undefined);

export const useChecklistsConfigContext = () => {
  const context = useContext(ChecklistsConfigContext);
  if (!context) {
    throw new Error('useChecklistsConfigContext must be used within a ChecklistsConfigProvider');
  }
  return context;
};

interface ChecklistsConfigProviderProps {
  children: ReactNode;
  hospital?: string;
}

export const ChecklistsConfigProvider: React.FC<ChecklistsConfigProviderProps> = ({ children, hospital }) => {
  const { checklistsConfig, loading, error } = useChecklistsConfig(hospital);

  return (
    <ChecklistsConfigContext.Provider value={{ checklistsConfig, loading, error }}>
      {children}
    </ChecklistsConfigContext.Provider>
  );
};
